<style lang="less" scoped>
  .contain {
    margin: 0 0 10px;
  }
  .could-go {
    cursor: pointer;
  }
  .mark {
    margin:0 8px;
    color: #999;
  }
  .could-go:hover {
    color:#2d8cf0
  }
</style>
<template>
  <div class="contain">
    <p v-if="list.length>0">
      <span
        v-for="(item,index) in list"
        :key="index"
        :class="{
          'could-go':item.path&&index!==list.length-1&&index!==0
        }"
        @click="item.path&&index!==list.length-1&&index!==0&&goTo(item)"
      >
        {{ item.name }}
        <span
          v-show="index!==list.length-1"
          class="mark"
        >/</span>
      </span>
    </p>
  </div>
</template>
<script>
  import { toHashOlder, jointRouterDetail } from '../../../libs/menus_util'
  export default {
    props: {
      standMenus: {
        type: Array,
        default:() => []
      }
    },
    data() {
      return {
        list:[],
        routerguard: null,
        routerHash:{}
      }
    },
    mounted() {
      const result = jointRouterDetail(this.standMenus)
      this.routerHash = toHashOlder(result)
      this.list = this.routerHash[window.location.pathname] || []
      this.routerguard = this.$router.beforeEach((to, from, next) => {
        this.list = this.routerHash[to.path] || []
        next()
      })
    },
    destroyed() {
      this.routerguard()
    },
    methods: {
      goTo(item) {
        this.$router.push(`${item.path}?rt=${new Date().getTime()}`)
      }
    }
  }
</script>
